import { varAlpha, createPaletteChannel } from 'minimal-shared/utils';

import { LINE } from '../ui-tokens';
import { themeConfig } from '../theme-config';

// ----------------------------------------------------------------------

// Primary color
export const primary = createPaletteChannel(themeConfig.palette.primary);

// Secondary color
export const secondary = createPaletteChannel(themeConfig.palette.secondary);

// Info color
export const info = createPaletteChannel(themeConfig.palette.info);

// Success color
export const success = createPaletteChannel(themeConfig.palette.success);

// Warning color
export const warning = createPaletteChannel(themeConfig.palette.warning);

// Error color
export const error = createPaletteChannel(themeConfig.palette.error);

// Common color
export const common = createPaletteChannel(themeConfig.palette.common);

// Grey color
export const grey = createPaletteChannel(themeConfig.palette.grey);

// Bluegrey color
const bluegrey = createPaletteChannel(themeConfig.palette.bluegrey);

// Pink color
const pink = createPaletteChannel(themeConfig.palette.pink);

// Purple color
const purple = createPaletteChannel(themeConfig.palette.purple);

// Yellow color
const yellow = createPaletteChannel(themeConfig.palette.yellow);

// Marine color
const marine = createPaletteChannel(themeConfig.palette.marine);

// Violet color
const violet = createPaletteChannel(themeConfig.palette.violet);

// Orange color
const orange = createPaletteChannel(themeConfig.palette.orange);

// Text color
const text = {
  light: createPaletteChannel({
    primary: grey[800],
    secondary: grey[600],
    disabled: grey[500],
  }),
  dark: createPaletteChannel({
    primary: '#FFFFFF',
    secondary: grey[500],
    disabled: grey[600],
  }),
};

// Background color
const background = {
  light: createPaletteChannel({
    paper: '#FFFFFF',
    default: '#F8F8F8', // grey 100 색상으로 통일
    neutral: grey[200],
  }),
  dark: createPaletteChannel({
    paper: grey[800],
    default: grey[900],
    neutral: '#28323D',
  }),
};

// Base action color
const baseAction = {
  hover: varAlpha(grey['500Channel'], 0.08),
  selected: varAlpha(grey['500Channel'], 0.16),
  focus: varAlpha(grey['500Channel'], 0.24),
  disabled: varAlpha(grey['500Channel'], 0.8),
  disabledBackground: varAlpha(grey['500Channel'], 0.24),
  hoverOpacity: 0.08,
  disabledOpacity: 0.48,
};

// Action color
const action = {
  light: { ...baseAction, active: grey[600] },
  dark: { ...baseAction, active: grey[500] },
};

// ----------------------------------------------------------------------

// Base palette
const basePalette = {
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  common,
  grey,
  bluegrey,
  pink,
  purple,
  yellow,
  marine,
  violet,
  orange,
  /**
   * **중립 테두리의 정본** — 카드·표·구분선이 전부 이 한 값을 쓴다(`LINE.edge`).
   * 🔑 같은 뜻의 색을 네 이름으로 부르고 있었다(`divider` #EDEDED · `grey.300` #E9E9EA ·
   *   `rgba(15,23,42,.08)` #ECECEE · 직접 쓴 `#E9E9EA`) — 여섯 단계 안의 같은 색이라 **보이는 차이는
   *   거의 없고**, 갈라져 있다는 사실만 값을 계속 늘렸다.
   * ⚠️ 뜻이 있는 테두리(고른 것 `primary.main` · 경고 `error.main`)는 여기 해당하지 않는다.
   */
  divider: LINE.edge,
};

export const palette = {
  light: {
    ...basePalette,
    text: text.light,
    background: background.light,
    action: action.light,
  },
  dark: {
    ...basePalette,
    text: text.dark,
    background: background.dark,
    action: action.dark,
  },
};
